@if (isReviewRequired()) {
  <div class="mb-4 flex flex-col gap-4 p-4 rounded-xl border border-amber-6 bg-amber-2 text-amber-12">
    <!-- Comparaison Profil vs Pièce d'identité -->
    @if (stripeVerifiedIdentity(); as stripeIdentity) {
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 border-amber-5">
        <div
          class="flex flex-col gap-1.5 p-3 rounded-xl bg-white/70 dark:bg-neutral-2 border border-amber-4 shadow-xs"
        >
          <span class="text-[11px] font-bold uppercase tracking-wider text-neutral-10"> Votre profil </span>
          <div class="flex items-center gap-2">
            <mat-icon class="text-neutral-9 text-base! w-4! h-4!">person</mat-icon>
            <span class="font-semibold text-sm text-neutral-12">
              {{ user().identity.firstName | titlecase }} {{ user().identity.lastName | titlecase }}
            </span>
          </div>
        </div>

        <div
          class="flex flex-col gap-1.5 p-3 rounded-xl bg-white/70 dark:bg-neutral-2 border border-amber-4 shadow-xs"
        >
          <div class="flex items-center justify-between">
            <span class="text-[11px] font-bold uppercase tracking-wider text-neutral-10">
              Pièce d'identité
            </span>
            @if (latestStripeSession()?.stripeSessionId ?? latestStripeSession()?._id; as sId) {
              <a
                [routerLink]="['/stripe-verification-sessions', sId]"
                class="text-[11px] font-medium text-primary-11 hover:underline flex items-center gap-0.5"
              >
                Voir session
                <mat-icon class="text-xs! w-3! h-3!">open_in_new</mat-icon>
              </a>
            }
          </div>
          <div class="flex items-center gap-2">
            <mat-icon class="text-neutral-9 text-base! w-4! h-4!">badge</mat-icon>
            <span class="font-semibold text-sm text-neutral-12">
              {{ stripeIdentity.firstName | titlecase }} {{ stripeIdentity.lastName | titlecase }}
            </span>
            @if (stripeIdentity.issuingCountry) {
              <span class="text-xs text-neutral-10 uppercase">({{ stripeIdentity.issuingCountry }})</span>
            }
          </div>
        </div>
      </div>
    } @else if (isLoadingStripeSession()) {
      <div class="text-xs text-amber-11 flex items-center gap-2 pt-3 border-t border-amber-5">
        <mat-icon class="animate-spin text-sm! w-4! h-4!">sync</mat-icon>
        <span>Recherche de la dernière session Stripe en cours...</span>
      </div>
    }

    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 pt-3 border-t border-amber-5">
      <div class="flex items-start gap-2.5 min-w-0">
        <mat-icon class="text-amber-9 shrink-0 mt-0.5">warning</mat-icon>
        <div class="flex flex-col min-w-0">
          <div class="flex items-center gap-2 flex-wrap">
            <span class="font-semibold text-sm">Vérification d'identité en attente de révision</span>
            @if (matchScore(); as score) {
              <span
                class="px-2 py-0.5 rounded-full text-[11px] font-bold border"
                [class]="
                  score >= 85
                    ? 'bg-jade-3 text-jade-11 border-jade-6'
                    : score >= 70
                      ? 'bg-amber-3 text-amber-11 border-amber-6'
                      : 'bg-ruby-3 text-ruby-11 border-ruby-6'
                "
              >
                Similarité : {{ score }}%
              </span>
            }
          </div>
          <span class="text-xs text-amber-11">
            Cette identité nécessite une décision manuelle suite au contrôle Stripe.
          </span>
        </div>
      </div>
      <div class="flex items-center gap-2 shrink-0">
        <button mat-flat-button class="primary text-xs!" (click)="openReviewModal()">
          <mat-icon class="mr-1 text-sm! w-4! h-4!">gavel</mat-icon>
          Statuer sur l'identité
        </button>
      </div>
    </div>
  </div>
}
